export default {
  clearFilter({ commit }) {
    commit("updateFilterRetailChain", [])
    commit("updateFilterPos", "")
    commit("updateFilterAreasCode", "")
    commit("updateFilterUF", "")
    commit("updateFilterCity", "")
    commit("updateFilterStatus", "")
  },

  updateRouteOnIndex: ({ state, commit }, index, newRoute) => {
    const newRoutes = state.stepNameRoutes
    newRoutes[index] = newRoute

    commit("updatStepNameRoutes", newRoutes)
  }
}
